<template>
  <div v-if="dataisload" id="modal-sizechart" class="modal fade" tabindex="-1" ref="modalsize">
    <div class="modal-dialog" style="max-width: 800px">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title position-relative" style="font-size: 24px">
            SIZE GUIDE
            <a
              class="close"
              href="#"
              data-dismiss="modal"
              style="right: 0px; top: 50%; padding: 0; transform: translateY(-50%); height: 22px"
            >
              <i class="d-block icon-close" />
            </a>
          </h4>
        </div>
        <div class="modal-body p-3">
          <div class="item-report">
            <div v-html="alldatas.SizeReport" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: ['alldatas', 'dataisload'],
  watch: {
    dataisload(val) {
      if (val) {
        this.$nextTick(() => {
          this.toggleSizeBlock();
        });
      }
    },
  },
  methods: {
    toggleSizeBlock() {
      const $modal = $(this.$refs.modalsize);
      const btnCollapse = $modal.find('.size-guide__section >h2');
      btnCollapse.click(function (e) {
        e.preventDefault();
        const $selfContent = $(this).parent().find('.size-guide__content');
        if ($(this).hasClass('show')) return;
        btnCollapse.removeClass('show');
        $(this).addClass('show');
        $('.size-guide__content').slideUp('400');
        $selfContent.slideDown('400');
      });
    },
  },
};
</script>
